<!-- 设置发票弹框 -->
<template>
        <el-dialog append-to-body :visible.sync="dialogVisible" width="70%">
            <div style="margin-bottom: 0.2rem;font-size: 0.2rem;">
                <span>发票金额的总和必须小于或等于订单金额</span>
                订单总额：<span style="color: red;margin-right: 0.1rem;">¥{{ orderPrice }}</span>
                已开发票金额：<span style="color: red;">¥{{ totalAmount }}</span>
                <span @click="selectInvoiceInfo" v-if="tableData.length > 0"
                    style="margin-left: 0.2rem;font-size: 0.17rem;cursor: pointer;text-decoration: underline;color: #CB582E;">选择已有数据</span>
            </div>
            <div class="lineBox" v-for="(item, index) in invoicingDetailList" :key="invoicingDetailList.length +  index">
                <div class="lineBoxTitle">
                    <p class="lineBoxTitleP1">第{{ index + 1 }}张发票</p>
                    <p @click="addClick(item)" class="lineBoxTitleP2" style="margin-right: 0.3rem;">增加</p>
                    <p v-if="invoicingDetailList.length > 2" @click="deleteClick(index)" class="lineBoxTitleP2">删除</p>
                </div>
                <div class="cardLineLineBox">
                    <div class="cardLine">
                        <p class="cardLineP1" style="margin-right: 0.2rem;"><span>*</span>发票类型:</p>
                        <el-select style="width: 3rem;" size="small" v-model="item.type" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="cardLine">
                        <p class="cardLineP1" style="margin-right: 0.2rem;"><span>*</span>发票抬头:</p>
                        <el-input placeholder="公司名称" style="width: 3rem;" size="small" v-model="item.lookUp"></el-input>
                    </div>
                    <div class="cardLine">
                        <p class="cardLineP1" style="margin-right: 0.2rem;"><span>*</span>税号:</p>
                        <el-input placeholder="纳税人识别号" style="width: 3rem;" size="small" v-model="item.duty"></el-input>
                    </div>
                    <div class="cardLine">
                        <p class="cardLineP1" style="margin-right: 0.2rem;"><span>*</span>发票金额:</p>
                        <el-input placeholder="请输入发票金额" style="width: 3rem;" size="small"
                            v-model="item.price"></el-input>
                    </div>
                    <div class="cardLine">
                        <p class="cardLineP1" style="margin-right: 0.2rem;"><span>*</span>发票内容:</p>
                        <el-input placeholder="请输入发票内容" style="width: 3rem;" size="small"
                            v-model="item.remark"></el-input>
                    </div>
                </div>
                <p>发票金额以实际开票金额为准</p>
            </div>
            <thereIsAlreadyAnInvoicePopUpBox :tableData="tableData" :planId="planId" @selectInvoice="selectInvoice" multipleChoiceOrNot
            ref="thereIsAlreadyAnInvoicePopUpBox"></thereIsAlreadyAnInvoicePopUpBox>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
</template>

<script>
import thereIsAlreadyAnInvoicePopUpBox from './thereIsAlreadyAnInvoicePopUpBox.vue';
export default {
    components: {
        thereIsAlreadyAnInvoicePopUpBox
    },
    props: {
        planId:{
            type: Number,
            default: null
        },
        tableData: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            dialogVisible: false,
            orderPrice: null,//订单总金额
            lookUp: null,//发票抬头
            invoicingDetailList: [
                {
                    "duty": "",//税号
                    "id": null,
                    "invoicingId": null,
                    "lookUp": "",//发票抬头
                    "price": null,//发票金额 要与所选择的 已支付的订单金额一致
                    "type": null,//0 企业 1 个人 2 非企业性单位
                    "remark": '',//备注
                }
            ],
            value: '',
            options: [{
                value: '0',
                label: '企业'
            }, {
                value: '1',
                label: '个人'
            }, {
                value: '2',
                label: '非企业性单位'
            }],
        }
    },
    computed: {
        totalAmount() {
            let price = 0
            this.invoicingDetailList.forEach(item => {
                price += Number(item.price)
            })
            return parseFloat(price).toFixed(2)
        }
    },
    watch: {},
    methods: {
        //选择已有发票信息
        selectInvoiceInfo() {
            this.$refs.thereIsAlreadyAnInvoicePopUpBox.open()
        },
        selectInvoice(rows) {
            if (rows.length > 0) {
                let arr = []
                rows.forEach(item => {
                    let obj = {
                        "duty": item.duty,
                        "id": null,
                        "invoicingId": null,
                        "lookUp": item.lookUp,
                        "price": item.invoicingPrice,
                        "type": String(item.invoicingType),
                        "remark": '',//备注
                    }
                    arr.push(obj)
                })
                this.$set(this, 'invoicingDetailList', [...this.invoicingDetailList, ...arr]);
            }
            console.log(this.invoicingDetailList, '发票信息');
        },
        //保存
        save() {
            if (!Number(this.totalAmount)) {
                return this.$message.warning({ message: '发票金额不能为0' })
            }
            if (!(Number(this.totalAmount) <= Number(this.orderPrice))) {
                return this.$message.warning({ message: '发票金额必须小于或等于订单金额' })
            }
            let arr = JSON.parse(JSON.stringify(this.invoicingDetailList))
            this.$emit('setInvoiceClick', arr)
            this.$message.success({ message: '保存成功' })
            this.dialogVisible = false
        },
        initClick(obj, arr) {
            if (arr.length > 1) {
                this.invoicingDetailList = arr
            } else {
                this.invoicingDetailList.forEach(item => {
                    item.lookUp = obj.lookUp
                })
                this.orderPrice = obj.orderPrice
                this.lookUp = obj.lookUp
            }
            console.log(this.orderPrice, obj, 'sadasdasddsadsa');
            this.dialogVisible = true
        },
        //删除
        deleteClick(index) {
            this.$delete(this.invoicingDetailList, index)
            this.$message.success({ message: '删除成功' })
        },
        //添加
        addClick(item) {
            let obj = JSON.parse(JSON.stringify(item))
            this.invoicingDetailList.push(obj)
            this.$message.success({ message: '新增成功' })
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.lineBox {
    margin-bottom: 0.3rem;

    .cardLineLineBox {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .cardLine {
            display: flex;
            align-items: center;
            margin-bottom: 0.15rem;
            margin-right: 0.25rem;

            .cardLineP1 {
                color: #606266;
                white-space: nowrap;

                span {
                    color: red;
                    margin-right: 0.05rem;
                }
            }
        }

    }

    .lineBoxTitle {
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;

        .lineBoxTitleP1 {
            font-size: 0.24rem;
            margin-right: 0.5rem;
        }

        .lineBoxTitleP2 {
            color: #57a4f2;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>